module.exports = __webpack_public_path__ + "media/images/riders/LAURA_STIGGER-461cfe25475bf7c388503960cb41701f.png";